import Container from "@material-ui/core/Container/index";
import React from "react";
import GetStartedHeaderWidget from '../header/GetStartedHeaderWidget';
import GetStartedBodyWidget from '../body/GetStartedBodyWidget';

class GetStartedWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        window.scrollTo(0, 0)
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Container>
                <GetStartedHeaderWidget appStyle={appStyle}/>
                <GetStartedBodyWidget appStyle={appStyle}/>
            </Container>
        );
    }
}

export default GetStartedWidget;